import React, { useEffect, useState } from "react";
import { Link } from "react-scroll";

const Navbar = () => {
    const [theme, setTheme] = useState(localStorage.getItem("theme") || "light");

    const toggleTheme = () => {
        setTheme((prevTheme) => (prevTheme === "light" ? "dark" : "light"));
    };

    useEffect(() => {
        localStorage.setItem("theme", theme);
        document.body.className = theme;
    }, [theme]);

    return (
        <>
            <header>
                <Link
                    className="logo"
                    activeClass="active"
                    smooth={true}
                    spy={true}
                    to="home"
                    offset={-400}
                >
                    <span style={{ color: 'rgb(236, 179, 101)' }}>pk</span>
                </Link>

                <nav>
                    <ul className="nav__links">
                        <li>
                            <Link activeClass="active" smooth={true} spy={true} to="home" offset={-400}>
                                <i className="fa-solid fa-home"></i> <span className="barname">Home</span>
                            </Link>
                        </li>

                        <li>
                            <Link activeClass="active" smooth={true} spy={true} to="about" offset={-120}>
                                <i className="fa-solid fa-user"></i> <span className="barname">About</span>
                            </Link>
                        </li>

                        <li>
                            <Link activeClass="active" smooth={true} spy={true} to="projects" offset={-130}>
                                <i className="fa-solid fa-folder-open"></i> <span className="barname">Projects</span>
                            </Link>
                        </li>

                        <li>
                            <Link activeClass="active" smooth={true} spy={true} to="contact" offset={-80}>
                                <i className="fa-solid fa-phone"></i> <span className="barname">Contact</span>
                            </Link>
                        </li>

                        <li className="toggle-theme" onClick={toggleTheme} style={{ cursor: "pointer" }}>
                            <i className={`fa-solid ${theme === "light" ? "fa-moon" : "fa-sun"}`}></i>
                        </li>
                    </ul>
                </nav>
            </header>
        </>
    );
};

export default Navbar;